import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { PermittedActivityService } from '../../services/permitted-activity/permitted-activity.service';
import { combineLatest } from 'rxjs';
import { ResponsiveDesignService, ScreenType } from '../../services/responsive-design/responsive-design.service';
import { InternalSettingsService } from '../../services/internal-settings/internal-settings.service';
import { Profile } from '../../services/internal-settings/internal-settings.interface';
import { PAMenuDesktop, PASection } from '../../services/permitted-activity/pa-menu-meta';
import { KeyValue } from '@angular/common';

@Component({
    selector: 'app-topbar-nav',
    templateUrl: './topbar-nav.component.html',
    styleUrls: ['./topbar-nav.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TopbarNavComponent implements OnInit {

  background!: Record<string, string>;
  profile!: Profile;
  
  hideSidebar!: boolean;

  constructor(private srvEs: ExternalSettingsService,
              protected srvPermitted: PermittedActivityService, 
              private srvRpDesign: ResponsiveDesignService,
              private srvIs: InternalSettingsService) { }

  ngOnInit(): void {
    this.srvRpDesign.screenType.subscribe((st) => {
      this.checkLayout(st);
    })

    combineLatest([this.srvEs.externalSettings$,
              this.srvIs.getCurrentSettings()]).subscribe(([es, is]) => {
                this.background = {
                  'background-color' : es.web.color_buttonbackground,
                  'border-color' : es.web.color_buttonbackground,
                  'color': 'white'
                }
          
                if (is != null) {
                  this.profile = is.profile;
                }
              })

  }


  checkLayout(screenType: ScreenType) {
    switch (screenType) {
      case ScreenType.TypeL:
      case ScreenType.TypeM:
      case ScreenType.TypeS:
      case ScreenType.TypeXS:
        this.hideSidebar = true;
        break;
      case ScreenType.TypeXL:
      default:
        this.hideSidebar = false;
        break;
    }
  }

  compareFn = (a: KeyValue<string, PASection>, b: KeyValue<string, PASection>): number => {
    return a.value.index - b.value.index;
  };
}
